// Thin typed WebSocket wrapper: connects to the same origin/port the page
// was served from (the server does double duty — see server/index.ts),
// sends ClientMessages, and dispatches parsed ServerMessages to a callback.

import type { ClientMessage, ServerMessage } from "../shared/types";

export class Net {
  private socket: WebSocket;
  private onMessageCallback: ((message: ServerMessage) => void) | null = null;
  private onStatusChangeCallback: ((connected: boolean) => void) | null = null;

  constructor() {
    const protocol = location.protocol === "https:" ? "wss:" : "ws:";
    this.socket = new WebSocket(`${protocol}//${location.host}`);
    this.socket.addEventListener("open", () => this.onStatusChangeCallback?.(true));
    this.socket.addEventListener("close", () => this.onStatusChangeCallback?.(false));
    this.socket.addEventListener("message", (event) => {
      let message: ServerMessage;
      try {
        message = JSON.parse(event.data);
      } catch {
        return; // ignore malformed input rather than crashing the client
      }
      this.onMessageCallback?.(message);
    });
  }

  send(message: ClientMessage): void {
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    }
  }

  onMessage(callback: (message: ServerMessage) => void): void {
    this.onMessageCallback = callback;
  }

  onStatusChange(callback: (connected: boolean) => void): void {
    this.onStatusChangeCallback = callback;
  }
}
